module.exports = __webpack_public_path__ + "static/media/ammonia.b1821622.png";